
const data = {
    projectDetails: {
      title:'GODREJ BIG BULL',
     title1:'At Kandivali, Mumbai',
      description:
        'Godrej Codename Big Bull Kandivali East is a special initiative made to provide you constant security and enable you to live without anxiety. Godrej Properties has recently secured an expansive 18.6-acre land in the vibrant city of Mumbai, strategically located in the thriving suburb of Kandivali. This acquisition marks a significant stride for the company as it seeks to enhance its presence in the highly competitive Mumbai real estate market. Godrej Big Bull spread across 13 acres of developable land parcel, this project is a symphony of urban design and natural beauty offering . The site is one of the largest freehold land parcels in western suburbs, a blend of Mumbai’s modern living and offers 3 towers with 52 floors each.',
      buttonText: 'Express your intrest',
      buttonIcon: 'fa-download',
      buttonColor: 'btn-danger',
    },
    Broucher:{
      title:'Download Brochure',
      submitButtonText: 'SUBMIT',
          },
    registrationForm: {
      title: 'Express your intrest',
      namePlaceholder: 'Your Name',
      emailPlaceholder: 'Your Phone Number',
      submitButtonText: 'Express your intrest',
      termsAndConditionsText: 'By Clicking Submit, I Accept The Terms & Conditions',
    },
    projectInfo: {
      comingSoonText: 'COMING SOON',
      projectName: 'GODREJ BIG BULL',
      location: 'At Kandivali, Mumbai By Godrej Properties',
      landParcel: '  18.5 Acres',
      floors: ' 6',
      possession: 'Coming Soon',
      offerBonanza1: 'EOI Window Open',
      offerBonanza2: 'Spot Booking Offers',
      offerBonanza3: 'Vastu Compliant Homes',
      offerBonanza4:'20+ Modern Amenities Bonanza',
      specialPriceText: 'Pre Book At ₹5 Lacs*',
      startingPrice: '₹ 2 Cr* Onwards',
      reraNumber: 'RERA No : P51800054671',
    },
  };


  const terms = 

  {
    
    title:'TERMS & CONDITIONS',
    paragraph:`MAHA RERA Act have come into effect from 1st may 2017. The content of website may not be be fully compliant with RERA as of date. We are in process of revising further details required as per RERA if pending any.
    We all possible measures to avoid any misrepresenration but makes no warranties as to the content and information accuracy. While reasonable efforts are being made to ensure the authenticity and completeness of the Information displayed here and the same is updated at regular intervals there is a possibility that the information displayed may not be current and incomplete.
    Please make sure you verify all the details from the actual site office or from the RERA website before making any decision in relation to the purchase of the properties.
    We accept no liability for the content of this website content, or for the consequences of any actions taken on the basis of this website or content. Property Prices, location map image, master plan image, opinion/suggestions provided in this mail are subject to change without notice and shall in no way make us responsible for any loss/damages caused to the users/members.`,
    Disclaimer:"The information provided on this website is intended exclusively for informational purposes and should not be construed as an offer of services. This site is managed by a RERA authorized real estate agent namely Propertypistol Realty Private Limited. The pricing information presented on this website is subject to alteration without advance notification, and the assurance of property availability cannot be guaranteed. The images showcased on this website are for representational purposes only and may not accurately reflect the actual properties. We may share your data with Real Estate Regulatory Authority (RERA) registered Developers for further processing as necessary. Additionally, we may send updates and information to the mobile number or email address registered with us. All rights reserved. The content, design, and information on this website are protected by copyright and other intellectual property rights. Any unauthorized use or reproduction of the content may violate applicable laws.For accurate and up-to-date information regarding services, pricing, availability, and any other details, it is recommended to contact us directly through the provided contact information on this website. Thank you for visiting our website.",
    para:'Contact us at – 2nd Floor, Arjun Building, Plot No – 6A, Vitthalbhai Patel Rd, Kalyangram Society, Lohana Colony, Andheri West, Mumbai 400058'  ,
agentNo:'Agent Maha RERA No. – A51700000043',
projectNo:'Project Maha RERA – COMING SOON'
};





// priceData.js
const priceList = [
  {
      flatSize: "2 BHK",
      sqFeet: "650+ sq.ft",
      price: "2 Cr* Onwards"
  },
  {
      flatSize: "3 BHK",
      sqFeet: "950+ sq.ft",
      price: "2.75 Cr* Onwards"
  },
 
];


const vistaplans=[
  {btn: "VIEW 2 BHK PLAN"},
  {btn: "VIEW 3 BHK PLAN"},
  {btn:"VIEW 4 BHK PLAN"}
]




  


 
  export { terms, data , priceList,vistaplans}